import { useEffect } from "react";
import { setChatLocalState } from "src/utils/localStorage";
import useSelector from "src/utils/useSelector";
import { getChatStateToPersist } from "src/components/Chat/redux/selectors";

export default function useChatPersistence() {
    const isAppOpen = useSelector((state) => state.onlineShopper.isAppOpen);
    const env = useSelector((state) => state.onlineShopper.env);
    const slug = useSelector((state) => state.account.slug);
    const enabled = useSelector((state) => state.account.settings?.electric?.message_center_enabled);

    const stateToPersist = useSelector(getChatStateToPersist);

    useEffect(() => {
        if (enabled && window.DIConversationsConfig !== undefined && isAppOpen) {
            setChatLocalState(stateToPersist, env, slug);
        }
    }, [stateToPersist, env, slug, isAppOpen, enabled]);
}
